import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "employeeProfile",
    "grossAmount",
    "netAmount",
    "taxAmount",
    "socialCharges",
    "advancesDeduction",
    "calculationDetails"
  ]

  connect() {
    if (this.hasEmployeeProfileTarget) {
      this.employeeProfileTarget.addEventListener('change', this.updateSalaryAmounts.bind(this))
    }
  }

  async updateSalaryAmounts(event) {
    const employeeProfileId = event.target.value
    if (!employeeProfileId) {
      this.resetForm()
      return
    }

    try {
      const response = await fetch(`/schools/payrolls/payslips/get_salary_amounts?employee_profile_id=${employeeProfileId}`)
      const data = await response.json()

      // Mettre à jour les champs avec les montants calculés
      this.grossAmountTarget.value = data.gross_amount
      this.netAmountTarget.value = data.net_amount
      this.taxAmountTarget.value = data.tax_amount
      this.socialChargesTarget.value = data.social_charges
      this.advancesDeductionTarget.value = data.advances_deduction
      this.calculationDetailsTarget.value = JSON.stringify(data.calculation_details)

      // Afficher les détails du calcul
      this.updateCalculationDetails(data.calculation_details)

    } catch (error) {
      console.error('Erreur lors de la récupération des montants:', error)
    }
  }

  resetForm() {
    this.grossAmountTarget.value = ''
    this.netAmountTarget.value = ''
    this.taxAmountTarget.value = ''
    this.socialChargesTarget.value = ''
    this.advancesDeductionTarget.value = ''
    this.calculationDetailsTarget.value = '{}'
  }

  updateCalculationDetails(details) {
    const container = document.getElementById('calculation-details')
    if (!container) return

    // Formater les montants en FCFA
    const formatAmount = (amount) => {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XOF',
        minimumFractionDigits: 0
      }).format(amount)
    }

    // Construire le contenu HTML
    const content = `
      <div class="col-span-2">
        <h4 class="font-medium mb-2">Salaire de base</h4>
        <p class="text-gray-900">${formatAmount(details.base_salary)}</p>
      </div>

      <div class="col-span-2">
        <h4 class="font-medium mb-2">Avantages récurrents</h4>
        <div class="space-y-1">
          ${Object.entries(details.recurring_benefits || {}).map(([key, value]) => `
            <div class="flex justify-between">
              <span class="text-gray-600">${key}</span>
              <span class="text-gray-900">${formatAmount(value)}</span>
            </div>
          `).join('')}
        </div>
      </div>

      <div class="col-span-2">
        <h4 class="font-medium mb-2">Charges sociales</h4>
        <div class="space-y-1">
          ${Object.entries(details.social_charges_breakdown || {}).map(([key, value]) => `
            <div class="flex justify-between">
              <span class="text-gray-600">${key}</span>
              <span class="text-gray-900">${value}%</span>
            </div>
          `).join('')}
        </div>
      </div>
    `

    container.innerHTML = content
  }
}
